import {Zero, Components} from 'Zero';
import $ from 'Vendor/jquery';

export default class ZFilters extends Components {

  get Selectors() {
    return {
      // FiltersCounter: '.filters-counter',
      // ApplyFiltersBtn: '.apply-filter-btn',
      // ClearFiltersBtn: '.clear-filter-btn',
      FilterInput: 'input[name="features"]'
    }
  }

  get react() {
    return {
      calculateFilters: function() {
        var filters = Zero.$state.StoreLocator.Filters;
      }
    }
  }

  constructor(element) {
    super(element);

    this.FiltersCounter = this.element.find( this.Selectors.FiltersCounter);
    this.FilterInput = this.element.find( this.Selectors.FilterInput );

    this.onFilterSelection();
    this.calculateFilters();
  }


  onFilterSelection() {
    this.FilterInput.on("change.filters", (e) => {
      e.preventDefault();
      $(".js-prefilter").attr('data-prefilter', '');
      this.applyFilters();
      this.onLabelCreation();
    });
  }


  onLabelCreation() {
    let filters = document.querySelectorAll('.mm_sl-filter-input:checked')

    if(filters.length > 0) {
      $('#filter-counter').empty();
      $('#filter-counter').append(`<span>${filters.length}</span>`);
    } else {
      $('#filter-counter').empty();
    }
  }


  applyFilters() {
    const filterArr = this.element.serializeArray();
    let resultArr = {};

    for(let object of filterArr) {
      let name = object.name;
      let value = object.value;

      if(resultArr[name]){
        if( ! $.isArray(resultArr[name]) ) {
          resultArr[name] = [resultArr[name]];
        }
        resultArr[name].push(value);

      } else {
        resultArr[name] = value;
      }
    }

    Zero.$state.StoreLocator.Filters = resultArr;
    return resultArr;
  }
}

export {
  ZFilters
}
